import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Award, Users, Target, TrendingUp } from 'lucide-react';

const About = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <div className="absolute inset-0 bg-gradient-to-br from-white to-gray-50 dark:from-gray-900 dark:to-gray-800"></div>
          <div className="absolute top-20 right-10 w-64 h-64 bg-blue-500 rounded-full opacity-10 blur-3xl animate-float"></div>
          <div className="absolute bottom-20 left-10 w-80 h-80 bg-green-500 rounded-full opacity-10 blur-3xl animate-float" style={{ animationDelay: '2s' }}></div>
        </div>

        <div className="container mx-auto px-4 z-10 relative">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 dark:text-white mb-6 animate-fadeInUp">
              {t('about.title')}
            </h1>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-white dark:bg-gray-900">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto space-y-12">
            <div className="prose prose-lg max-w-none animate-fadeInUp">
              <p className="text-xl text-gray-700 dark:text-gray-300 leading-relaxed">
                {t('about.content1')}
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8 my-16">
              {[
                { icon: Award, title: '2019', desc: 'Kuruluş Yılı' },
                { icon: Users, title: '500+', desc: 'Tamamlanan Proje' },
                { icon: Target, title: '100+', desc: 'Mutlu Müşteri' },
                { icon: TrendingUp, title: '15+', desc: 'Sektör Deneyimi' }
              ].map((stat, index) => (
                <div
                  key={index}
                  className="flex items-center gap-6 p-6 rounded-2xl bg-gradient-to-br from-gray-50 to-white dark:from-gray-800 dark:to-gray-700 border-2 border-gray-100 dark:border-gray-600 hover:border-[#F05627] hover:shadow-xl transition-all duration-300 animate-fadeInUp"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="w-16 h-16 bg-orange-50 rounded-xl flex items-center justify-center flex-shrink-0">
                    <stat.icon className="w-8 h-8 text-[#F05627]" />
                  </div>
                  <div>
                    <div className="text-3xl font-bold text-gray-900 dark:text-white">{stat.title}</div>
                    <div className="text-sm text-gray-600 dark:text-gray-400">{stat.desc}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="prose prose-lg max-w-none animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
              <p className="text-xl text-gray-700 dark:text-gray-300 leading-relaxed">
                {t('about.content2')}
              </p>
            </div>

            <div className="prose prose-lg max-w-none animate-fadeInUp" style={{ animationDelay: '0.4s' }}>
              <p className="text-xl text-gray-700 dark:text-gray-300 leading-relaxed">
                {t('about.content3')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-gray-50 dark:bg-gray-800">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-4xl font-bold text-center text-gray-900 dark:text-white mb-16 animate-fadeInUp">
              Değerlerimiz
            </h2>
            <div className="grid md:grid-cols-3 gap-8">
              {[
                {
                  title: 'Güvenilirlik',
                  description: 'Müşterilerimize her zaman doğru ve güvenilir veriler sunuyoruz.'
                },
                {
                  title: 'Yenilikçilik',
                  description: 'En son araştırma metodolojileri ve teknolojileri kullanıyoruz.'
                },
                {
                  title: 'Şeffaflık',
                  description: 'Tüm süreçlerimizde açık ve net iletişim sağlıyoruz.'
                }
              ].map((value, index) => (
                <div
                  key={index}
                  className="p-8 bg-white dark:bg-gray-700 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 animate-fadeInUp"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">{value.title}</h3>
                  <p className="text-gray-600 dark:text-gray-300">{value.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;